function sculpteoWidget(name, api, remote, id) {
  this.api = api;
  this.root = window.name;
  this.name = name;
  this.remote = remote;

  if (remote == "file://" || remote == "data://") {
    // Local cases.
    this.remote = false;
  }

  this.id = id;

  var widget = this;

  if (window.addEventListener) {
    window.addEventListener(
      "message",
      function (event) {
        widget.handleMessage.call(widget, event);
      },
      false
    );
  } else {
    window.attachEvent("onmessage", function (event) {
      widget.handleMessage.call(widget, event);
    });
  }

  widget.sendEvent(["ready_" + window.name]);
}

sculpteoWidget.prototype = {
  sendEvent: function (args) {
    var nameid = this.root + " " + this.name;

    if (this.id) {
      nameid += ":" + this.id;
    }

    var str = nameid + "/" + args[0];

    for (var i = 1; i < args.length; i++) {
      str += (i == 1 ? "?" : "&") + encodeURIComponent(args[i]);
    }

    if (window.parent && window.parent.postMessage) {
      window.parent.postMessage(str, this.remote ? this.remote : "*");
    }
  },

  handleMessage: function (event) {
    if (this.remote && event.origin != this.remote) {
      return;
    }

    var h = event.data;

    if (!!h.indexOf(this.name)) {
      return;
    }

    h = h.substr(this.name.length);
    var channel = null;

    if (!h.indexOf(":")) {
      var i = h.indexOf("/");

      channel = h.substring(1, i);
      h = h.substr(i);
    }

    h = h.substr(1);
    var mp = h.split("?");
    var method = mp[0];
    var args = mp[1] ? mp[1].split("&") : [];

    for (var k in args) {
      args[k] = unescape(args[k]);
    }

    var nameid = this.root + " " + this.name;

    if (this.id) {
      nameid += ":" + this.id;
    }

    var onerror = function (e) {
      if (channel) {
        event.source.postMessage(
          nameid + "/" + channel + "/error?" + encodeURIComponent(e),
          "*"
        );
      }
    };

    var onsuccess = function (ret) {
      if (channel) {
        event.source.postMessage(
          nameid + "/" + channel + "/return?" + encodeURIComponent(ret),
          "*"
        );
      }
    };

    try {
      this.api(method, args, onsuccess, onerror);
    } catch (e) {
      onerror(e);
    }
  },
};
